import Vue from 'vue';
import SalesPartnerCommission from '@/plugins/graphql/queries/v2/sales-partner-total-commission.gql';
import AnimatedNumber from 'animated-number-vue';
import LinkButton from '@/components/link_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
export default Vue.extend({
    components: {
        AnimatedNumber,
        LinkButton,
    },
    mixins: [ViewportSizeMixin],
    apollo: {
        totalCommission: {
            query: SalesPartnerCommission,
            variables() {
                return {
                    userUuid: this.userUuid,
                };
            },
            update(data) {
                return data.salesPartnerTotalCommission;
            },
            fetchPolicy: 'cache-and-network',
        },
    },
    props: {
        userUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            totalCommission: {},
        };
    },
    methods: {
        filterValue(value) {
            const options = this.$options;
            if (!!options && !!options.filters && !!options.filters.currency) {
                return options.filters.currency(value);
            }
            return '0.0';
        },
        goToSalesPartnerPayout() {
            this.$router.push({ name: 'affiliate-payouts' });
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-layout', {
            class: 'payout-widget column',
        }, [
            createElement('v-card', {
                class: 'billing-widget mt-2 mr-2 ml-2 -seashell-bg -payout',
                props: {
                    flat: true,
                },
            }, [
                createElement('v-layout', { class: 'column align-center justify-center pa-2' }, [
                    createElement('v-layout', {
                        class: 'column',
                    }, [
                        createElement('v-flex', { class: 'shrink' }, [
                            createElement('base-text', {
                                props: {
                                    text: 'Payout Amount',
                                    fontSize14: true,
                                    centered: true,
                                },
                                class: 'mb-0 mr-2 font-weight-black',
                            }),
                        ]),
                        createElement('v-flex', {
                            class: 'text-xs-center',
                        }, [
                            createElement('animated-number', {
                                props: {
                                    value: self.totalCommission,
                                    duration: self.duration,
                                    formatValue: self.filterValue,
                                    xs12: self.xsOnly,
                                },
                                class: 'orange--text text--darken-3 font-weight-bold font-size-24',
                            }),
                        ]),
                        createElement('v-flex', {
                            class: 'text-xs-center',
                        }, [
                            createElement('router-link', {
                                props: {
                                    to: { name: 'affiliate-payouts' },
                                },
                                class: 'text-capitalize blue--text pt-0',
                                style: 'font-size: 14px;',
                            }, 'View Payout Details'),
                        ]),
                    ]),
                ]),
            ]),
            createElement('base-text', {
                props: {
                    text: 'ChatGenie distributes the payout to verified Sales Partner only',
                    fontSize10: true,
                    textGreyLight3: true,
                },
                class: 'mb-0 text-xs-center ml-2 pr-3',
            }),
        ]);
    },
});
